// @flow
import context from 'app/common/lib/context';
import logStats from 'app/common/lib/logStats';

export default function logPerfTiming(routePath: string) {
  if (window.performance && window.performance.getEntriesByType) {
    const navigationTimings = window.performance.getEntriesByType('navigation');
    const paintTimings = window.performance.getEntriesByType('paint');
    if (navigationTimings.length > 0) {
      const navigationTiming = navigationTimings[0];
      const performanceInfo = {
        domContentLoaded: navigationTiming.domContentLoadedEventEnd - navigationTiming.requestStart,
        interactive: navigationTiming.domInteractive - navigationTiming.requestStart,
        total: navigationTiming.responseEnd - navigationTiming.requestStart,
        ttfb: navigationTiming.responseStart - navigationTiming.requestStart,
      };

      paintTimings.forEach((paintTiming) => {
        performanceInfo[paintTiming.name] = paintTiming.startTime - navigationTiming.requestStart;
      });

      const connection =
        window.navigator.connection ||
        window.navigator.mozConnection ||
        window.navigator.webkitConnection;
      const connectionType =
        connection && connection.effectiveType ? connection.effectiveType : 'unknown';

      Object.keys(performanceInfo).forEach((key) => {
        logStats.timing(`webapp.clientPerfTimings.${key}`, performanceInfo[key], 1, {
          browserName: context.instance.browser_name,
          browserVersion: context.instance.browser_version,
          connectionType,
          isAuthenticated: context.instance.is_authenticated,
          isBot: context.instance.is_bot === 'true',
          route: routePath,
          stage: context.initialPageContext.stage,
        });
      });
    }
  }
}
